import UserProfileService from './userProfile.service';
import { queryOptions, UseMutationResult, useQuery, UseQueryResult } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import useUserProfileMutation from './userProfile.mutation';

interface IUseUserProfile {
  executeUserProfileAction: any;
  isUpdating: any;
  setIsUpdating: any;
  executeUserProfileActionMutation: any;
}

const useUserProfile = (agentId?: number): IUseUserProfile => {
  const { executeUserProfileAction, isUpdating, setIsUpdating, executeUserProfileActionMutation } = useUserProfileMutation();

  return {
    executeUserProfileAction,
    isUpdating,
    setIsUpdating,
    executeUserProfileActionMutation,
  };
};

export default useUserProfile;


export const createAllUsersQueryOptions = () => queryOptions<any>({
  queryKey: ['all-users'],
  queryFn: async () => {
    const userProfileService = UserProfileService();
    return new Promise(async (resolve) => {
      await userProfileService
        .getAllUsers({
          onSuccess: (res: AxiosResponse) => {
            resolve(res.data);
          },
        })
        .then((res) => {
          resolve(res?.data);
        });
    });
  },
  staleTime: 1000 * 60 * 5, // 5 minutes
  refetchInterval: 1000 * 60 * 5, // 5 minutes
  refetchOnWindowFocus: false,
});
